function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.7753 1.22475C19.0194 1.46882 19.0194 1.86455 18.7753 2.10863L9.60863 11.2753C9.36455 11.5194 8.96882 11.5194 8.72475 11.2753C8.48067 11.0312 8.48067 10.6355 8.72475 10.3914L17.8914 1.22475C18.1355 0.980668 18.5312 0.980668 18.7753 1.22475Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.7753 1.2247C18.945 1.39448 19.0026 1.6465 18.9232 1.87311L13.0899 18.5398C13.0052 18.7817 12.7815 18.9473 12.5255 18.9578C12.2694 18.9682 12.0329 18.8213 11.9289 18.5871L8.69316 11.3068L1.41282 8.07111C1.17865 7.96703 1.03173 7.73055 1.04218 7.4745C1.05263 7.21845 1.21832 6.99472 1.46019 6.91007L18.1269 1.07673C18.3535 0.997416 18.6055 1.05493 18.7753 1.2247ZM3.36108 7.5691L9.4205 10.2622C9.56189 10.325 9.67495 10.4381 9.73779 10.5795L12.4309 16.6389L17.3146 2.68537L3.36108 7.5691Z",
  fill: "currentColor"
});

function SvgSend(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.419666fc.svg";
export { ForwardRef as ReactComponent };